/* loaded by smart-asset */
export default require("./assets/drop-zone-pallet.i.svg")